<table mat-table [dataSource]="dataSource" matSort>

  <!--<ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> {{ 'pages.addresses.table.name' | translate }} </th>
      <td mat-cell *matCellDef="let address">
          {{ 'general.salutations.'+address.salutation | translate }} {{ address.firstName }} {{ address.lastName }}
      </td>
  </ng-container>-->


  <ng-container matColumnDef="salutation">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.mitarbeiterverwaltung.table.salutation' | translate }} </th>
    <td mat-cell *matCellDef="let mitarbeiter"> {{mitarbeiter.anrede }} </td>
  </ng-container>

  <ng-container matColumnDef="firstName">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.mitarbeiterverwaltung.table.firstName' | translate }} </th>
    <td mat-cell *matCellDef="let mitarbeiter"> {{ mitarbeiter.vorname }} </td>
  </ng-container>

  <ng-container matColumnDef="lastName">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.mitarbeiterverwaltung.table.lastName' | translate }} </th>
    <td mat-cell *matCellDef="let mitarbeiter"> {{ mitarbeiter.name }} </td>
  </ng-container>

  <ng-container matColumnDef="email" >
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.mitarbeiterverwaltung.table.email' | translate }} </th>
    <td mat-cell *matCellDef="let mitarbeiter"> {{mitarbeiter.email}} </td>
  </ng-container>

  <ng-container matColumnDef="mobile" >
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.mitarbeiterverwaltung.table.mobile' | translate }} </th>
    <td mat-cell *matCellDef="let mitarbeiter"> {{mitarbeiter.mobile}} </td>
  </ng-container>

  <ng-container matColumnDef="birthday">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.mitarbeiterverwaltung.table.birthday' | translate }} </th>
    <td mat-cell *matCellDef="let mitarbeiter">
      {{ mitarbeiter.geburtstag | date:'dd.MM.yyyy'}}
    </td>
  </ng-container>



  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td  mat-cell *matCellDef="let mitarbeiter" >
      <button class="action-menu-button" mat-icon-button [matMenuTriggerFor]="actionMenu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #actionMenu="matMenu">
        <button [disabled]="!showFunctions" *ngIf="mitarbeiter.aktiv==true" mat-menu-item (click)="zeiterfassung(mitarbeiter.id)">{{ 'pages.mitarbeiterverwaltung.actions.zeiterfassung' | translate }}</button>
        <button [disabled]="!showFunctions" *ngIf="mitarbeiter.aktiv==true" mat-menu-item (click)="editMitarbeiter.emit(mitarbeiter)">{{ 'pages.mitarbeiterverwaltung.actions.edit' | translate }}</button>
        <button [disabled]="!showFunctions" *ngIf="mitarbeiter.aktiv==true && mitarbeiter.rolle!='Admin'" mat-menu-item (click)="deleteMitarbeiter.emit(mitarbeiter)">{{ 'pages.mitarbeiterverwaltung.actions.delete' | translate }}</button>
        <button [disabled]="!showFunctions" *ngIf="mitarbeiter.aktiv==false" mat-menu-item (click)="reactivateMitarbeiter.emit(mitarbeiter)">{{ 'pages.mitarbeiterverwaltung.actions.aktivieren' | translate }}</button>
      </mat-menu>
    </td>
  </ng-container>

  <tr mat-header-row class="header-table-row" *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
  <ng-container *ngIf="!showFunctions">
    <tr mat-row class="table-row" *matRowDef="let myRowData; columns: displayedColumns"></tr>
  </ng-container>
  <ng-container *ngIf="showFunctions">
    <tr mat-row class="table-row" *matRowDef="let myRowData; columns: displayedColumns" (dblclick)="editMitarbeiter.emit(myRowData)"></tr>
  </ng-container>

</table>
